<template>
  <span :style="`color: ${color}`">{{ answerText }}</span>
</template>

<script>
import authorAnswerColors from './mixins/authorAnswerColors';
export default {
  props: ['value'],
  mixins: [authorAnswerColors],
  computed: {
    answerData() {
      return this.answers.find(a => a.value == this.value[0]);
    },
    answerText() {
      if (this.answerData) {
        const confidence = this.value[1] == 2 ? 'and Pretty Sure' : 'but not sure yet';
        return this.answerData.text[0] + ' ' + this.answerData.text[1] + ' ' + confidence;
      } else {
        return 'NO ANSWER YET';
      }
    },
    color() {
      return this.value[0] ? this.colors[this.value[0]] : this.colors[0];
    }
  }
};
</script>
